// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UFsA","index":"styles_index__2mD9R"};